import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// --- IMPORT KOMPONEN ---
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Sidebar from './components/Sidebar';
import SiswaList from './components/SiswaList';
import SiswaForm from './components/SiswaForm';
import GuruList from './components/GuruList';
import GuruForm from './components/GuruForm';
import KelasManager from './components/KelasManager';
import MapelManager from './components/MapelManager';
import JadwalManager from './components/JadwalManager';
import JurnalPiket from './components/JurnalPiket';
import Settings from './components/Settings';
import UserManager from './components/UserManager';

// --- IMPORT FITUR UTAMA & TAMBAHAN ---
import AbsenPage from './components/AbsenPage';
import PoinPage from './components/PoinPage';
import KenaikanKelas from './components/KenaikanKelas';
import SuratPeringatan from './components/SuratPeringatan';
import CetakKartu from './components/CetakKartu';
import GantiPassword from './components/GantiPassword';

import MonitoringKBM from './components/MonitoringKBM';
import AbsenGuru from './components/AbsenGuru';
import RekapPage from './components/RekapPage';         
import RekapBulanan from './components/RekapBulanan';   
import RekapAbsenGuru from './components/RekapAbsenGuru'; 

const App = () => {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [role, setRole] = useState(localStorage.getItem('role'));
  const [nama, setNama] = useState(localStorage.getItem('nama'));

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    const storedRole = localStorage.getItem('role');
    const storedNama = localStorage.getItem('nama');
    if (storedToken) {
        setToken(storedToken);
        setRole(storedRole);
        setNama(storedNama);
    }
  }, []);

  const handleLogin = (newToken, newRole, newNama) => {
    // 1. Ambil nama riil atau gunakan fallback teratur
    const namaValid = newNama || 'Admin / Staff';
    
    // 2. Simpan ke storage secara persisten
    localStorage.setItem('token', newToken);
    localStorage.setItem('role', newRole);
    localStorage.setItem('nama', namaValid);
    
    // 3. Wajib set state secara langsung agar UI Sidebar langsung me-refresh nilainya
    setToken(newToken);
    setRole(newRole);
    setNama(namaValid);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('nama');
    localStorage.removeItem('siswaId');
    localStorage.removeItem('guruId');
    setToken(null);
    setRole(null);
    setNama(null);
    window.location.href = '/'; 
  };

  if (!token) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="app-container">
      {/* Parameter nama terkirim secara dinamis dan reaktif */}
      <Sidebar role={role} nama={nama} onLogout={handleLogout} />

      <div className="main-content">
        <Routes>
          <Route path="/" element={<Dashboard token={token} role={role} />} />
          
          {/* --- HALAMAN ABSENSI KELAS --- */}
          <Route path="/absen" element={<AbsenPage token={token} />} />

          {/* --- HALAMAN BUKU SAKU (POIN) --- */}
          <Route path="/poin" element={<PoinPage token={token} />} />
          <Route path="/surat-peringatan/:id" element={<SuratPeringatan token={token} />} />

          {/* --- MANAJEMEN DATA --- */}
          <Route path="/siswa" element={<SiswaList token={token} />} />
          <Route path="/siswa/tambah" element={<SiswaForm token={token} />} />
          <Route path="/siswa/edit/:id" element={<SiswaForm token={token} />} />
          
          <Route path="/cetak-kartu" element={<CetakKartu token={token} />} />
          <Route path="/cetak-kartu/:id" element={<CetakKartu token={token} />} />
          
          <Route path="/guru" element={<GuruList token={token} />} />
          <Route path="/guru/tambah" element={<GuruForm token={token} />} />
          <Route path="/guru/edit/:id" element={<GuruForm token={token} />} />
          
          <Route path="/kelas" element={<KelasManager token={token} />} />
          <Route path="/mapel" element={<MapelManager token={token} />} />
          <Route path="/jadwal" element={<JadwalManager token={token} />} />
          
          {/* --- FITUR KHUSUS ADMIN --- */}
          <Route path="/kenaikan-kelas" element={<KenaikanKelas token={token} />} />
          <Route path="/settings" element={<Settings token={token} />} />
          <Route path="/users" element={<UserManager token={token} />} />

          {/* --- FITUR UMUM --- */}
          <Route path="/ganti-password" element={<GantiPassword token={token} />} />

          {/* --- MONITORING & REKAP --- */}
          <Route path="/monitoring" element={<MonitoringKBM token={token} />} />
          <Route path="/absen-guru" element={<AbsenGuru token={token} />} />
          <Route path="/jurnal" element={<JurnalPiket token={token} />} />

          <Route path="/rekap-harian" element={<RekapPage token={token} />} />
          <Route path="/rekap-bulanan" element={<RekapBulanan token={token} />} />
          <Route path="/rekap-guru" element={<RekapAbsenGuru token={token} />} />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;